import { render, staticRenderFns } from "./Reservations_dialog.vue?vue&type=template&id=a05b585e&scoped=true&"
import script from "./Reservations_dialog.vue?vue&type=script&lang=js&"
export * from "./Reservations_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Reservations_dialog.vue?vue&type=style&index=0&id=a05b585e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b585e",
  null
  
)

export default component.exports